
import { DateTime } from 'luxon'
import Swal from 'sweetalert2'
import Vue from 'vue'
import { ParsedQuery } from 'query-string'
import type { DefaultNuxtLoading } from '@nuxt/types/app'

interface IData {
  filename: string | null
  paste: string | null
  loading: boolean
}

export default Vue.extend({
  data: (): IData => ({
    filename: null,
    paste: null,
    loading: false
  }),

  methods: {
    async submit() {
      if (!this.paste) {
        return
      }

      try {
        this.loading = true

        const filename = this.filename || `${DateTime.now().toFormat('kkkk-LL-dd_HH-mm')}.txt`
        const file = new File([this.paste], filename)

        // Upload to MFS
        const { cid } = await this.$accessor.ipfs.upload({
          files: [file],
          loading: this.$nuxt.$loading as DefaultNuxtLoading,
          path: '.pastebin'
        })

        this.$events.emit('upload.success')

        // Request caching on the most popular gateway
        // await this.$accessor.ipfs.finishUpload(cid)

        const query: ParsedQuery = {
          uploader: 'true', // More appropriate messages for the uploader
          cid,
          name: filename
        }

        // Open explorer
        this.$router.push({
          path: '/explorer',
          query
        })
      } catch (err: any) {
        Swal.fire({
          title: 'A problem has occurred',
          text: err.message,
          icon: 'error'
        })

        console.trace(err)
      } finally {
        this.loading = false
      }
    }
  }
})
